import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider, Grid,
  IconButton,
  Progress
} from 'web-library';
import {useTheme} from '@mui/material/styles';

import {makeStyles} from 'tss-react/mui';
import {IconName} from 'web-library/stories/atom/Icon/Icon';
import {PaginatedData} from 'web-library/models/List';
import {AnnouncementDetail} from 'web-library/models/Announcements';
import {useGetPaymentMessages} from "../../../api-refactored/announcements/useGetPaymentMessages";
import PaymentContent from "./PaymentContent";
import {useHistory} from "react-router-dom";

const useStyles = makeStyles()((theme) =>
    ({
      announcementTitleContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(2.5),
      },
      divider: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(-2),
      },
    }));

interface AnnouncementContentProps {
  openAnnouncementModal: boolean;
  setOpenAnnouncementModal: React.Dispatch<React.SetStateAction<boolean>>;
  redirectURL: string;
}

const PaymentAnnouncementContent = ({
                                      openAnnouncementModal,
                                      setOpenAnnouncementModal,
                                      redirectURL,
                                    }: AnnouncementContentProps) => {
  const {classes} = useStyles();

  const history = useHistory();
  const theme = useTheme();

  const {data: priorityAnnouncements, isLoading} = useGetPaymentMessages({
    requestData: {
      apiPathParam: {},
    },
    onSuccess: (data) => {
      if ((data.content?.length ?? 0) > 0) {
        setOpenAnnouncementModal(true);
      } else {
        setOpenAnnouncementModal(false);
        history.push(redirectURL);
      }
    }
  });

  const handleCloseAnnouncementModal = () => setOpenAnnouncementModal(false);

  const displayPriorityAnnouncements = (
      priorityAnnouncementPage: PaginatedData<AnnouncementDetail> | undefined
  ) =>
      priorityAnnouncementPage?.content?.map(
          (priorityAnnouncement: AnnouncementDetail, index: number) => (
              <>
                <PaymentContent announcementNoticeDetails={priorityAnnouncement}/>
                {index !== (priorityAnnouncementPage.content?.length ?? 0) - 1 && (
                    <Divider className={classes.divider}/>
                )}
              </>
          )
      )

  return (
      <>
        {openAnnouncementModal && (priorityAnnouncements?.content?.length ?? 0) > 0 && (
            <Dialog open={openAnnouncementModal} maxWidth="lg">
              <DialogTitle>
                <Box className={classes.announcementTitleContainer}>
                  <Box>
                    <IconButton
                        id="button-announcement-content-close"
                        name={IconName.cross}
                        iconSize="S"
                        color={theme.color.icon.iconDefault}
                        ariaLabel="announcement-content-close"
                        onClick={handleCloseAnnouncementModal}
                    />
                  </Box>
                </Box>
              </DialogTitle>
              <DialogContent>
                {isLoading && <Progress color="secondary"/>}
                {displayPriorityAnnouncements(priorityAnnouncements)}
              </DialogContent>
              <DialogActions id="announcement-dialog-action">
                <Grid container justify="flex-end" wrap="nowrap" direction="row">
                  {redirectURL && (
                      <Button
                          variant="contained"
                          disabled={isLoading}
                          onClick={() => {
                            setOpenAnnouncementModal(false);
                            history.push(redirectURL);
                          }}
                      >
                        Confirm
                      </Button>
                  )}
                </Grid>
              </DialogActions>
            </Dialog>
        )}
      </>
  );
};

export default PaymentAnnouncementContent;
